import axios from "axios";
import paths from '../../../../paths.json';
import { logApiRequest } from "../../../common/mixpanelInterface";

export default async function uploadInfluencerHeader(file, component, doubleUpload) {
    const form_data = new FormData();
    form_data.append('content_type', file.type)
    form_data.append('file_size', file.size)
    try {
        const startTime1 = performance.now()
        const response = await axios({
            method: 'post',
            url: paths.BACKEND_URL + 'api/influencer/edit/intro',
            data: form_data,
            // onUploadProgress(progressEvent) {
            //     const { loaded, total } = progressEvent;
            //     let percent = Math.floor((loaded * 100) / total);
            //   },
            withCredentials: true
        });
        logApiRequest(paths.BACKEND_URL + 'api/influencer/edit/intro', performance.now() - startTime1);
            // Post to S3
            // const r = await fetch(response.data.upload_uri, {
            //     method: 'PUT',
            //     body: file
            // });

            this.setState({uploadPercent:0, 
                uploadMessage: 'Uploading', 
                uploadStep: doubleUpload ? 'Step 2 of 6:' : 'Step 2 of 3:'
            })
            const r = 
                await axios.put(response.data.upload_uri, file, {
                    headers: {
                        'Content-Type': file.type
                    },
                    signal: this.state.controller.signal,
                    onUploadProgress: progressEvent => {
                        if (this.state.fileSize === 0) {
                            this.setState({uploadStartTime: Date.now()})
                            this.setState({fileSize:progressEvent.total}, () => {
                                const networkCheck = setInterval(() => {
                                    this.setState({
                                        uploadSpeeds: [...this.state.uploadSpeeds,
                                            (this.state.uploadPercent * this.state.fileSize)/(100*(Date.now()-this.state.uploadStartTime))
                                        ]
                                    }, () => {
                                        if (this.state.uploadSpeeds.length >=3 && this.state.uploadPercent!==100) {
                                            const speedsArr = [...this.state.uploadSpeeds]
                                            const uploadSpeedAvg = speedsArr.reduce((a,b) => a+b,0)/speedsArr.length
                                            const remainingBytes = this.state.fileSize * (1 - this.state.uploadPercent/100)
                                            const secondsRemaining = 0.001* remainingBytes / uploadSpeedAvg
                                            this.setState({timeRemaining: Math.round(secondsRemaining)})
                                        }
                                    })
                                    if (this.state.uploadPercent === 100) {
                                        clearInterval(networkCheck)
                                    }
                                },500)
                            })
                        }
                        let uploadString =''
                        if (progressEvent.total >= 1048576) {
                            const uploadMB = Math.round(progressEvent.loaded / 1048576)
                            const totalSizeMB = Math.round(progressEvent.total / 1048576)
                            uploadString = `${uploadMB}MB of ${totalSizeMB}MB`
                        }
                        else if (progressEvent.total >= 1024) {
                            const uploadKB = Math.round(progressEvent.loaded / 1024)
                            const totalSizeKB = Math.round(progressEvent.total / 1024)
                            uploadString = `${uploadKB}KB of ${totalSizeKB}KB`
                        }
                        else {
                            const uploadBytes = Math.round(progressEvent.loaded)
                            const totalSizeBytes = Math.round(progressEvent.total)
                            uploadString = `${uploadBytes}Bytes of ${totalSizeBytes}Bytes`
                        }
                        if (Math.round(this.state.uploadPercent) === 100) {
                            return
                        }
                        this.setState({uploadPercent: (progressEvent.loaded/progressEvent.total)*100, uploadMessage: `Uploading video...(${uploadString})`})
                }})
                
                
                component === 'influencer_banner_video' && this.setState({
                    uploadPercent:100, 
                    uploadMessage: 'Processing video...', 
                    uploadStep: doubleUpload ? 'Step 3 of 6:' : 'Step 3 of 3:', 
                    timeRemaining: 0
                })
            // More in-depth percentage can't be done with feth method
            
                // await axios({
                //     url: response.data.upload_uri,
                //     method: 'put',
                //     data: file,
                //     onUploadProgress(progressEvent) {
                //         const { loaded, total } = progressEvent;
                //         let percent = Math.floor((loaded * 100) / total);
                //       },
                // })
            const startTime2 = performance.now()
            const response2 = await axios({
                method: 'get',
                url: response.data.completed_uri,
                // onDownloadProgress: progressEvent => {
                //     let percentCompleted = Math.floor(progressEvent.loaded / progressEvent.total * 100)
                //   },
                withCredentials: true
            });
            // 1. Make a shallow copy of the items
            let influencer_info = this.state.influencer_info;
            // 3. Replace the property you're intested in
            influencer_info['intro_video_path'] = response2.data.file_name
            // 5. Set the state to our new copy
            this.setState({influencer_info: influencer_info});
            logApiRequest(response.data.completed_uri, performance.now() - startTime2);
            component === 'influencer_banner_video' && this.setState({
                uploadPercent: 100, 
                uploadMessage: doubleUpload ? 'Video uploaded': 'Finished',
                isUploading: false,
                fileSize:0,
                uploadStartTime: null,
                header_file: null
            })
    }
    catch(err) {
        this.setState({
            isUploading: false,
            fileSize: 0,
            uploadError: true,
            snackbarAutoHide: 6000
        })
        const error = err.response.data.error
        if (error === 'Invalid Type') {
            this.setState({
                uploadErrorMsg: 'Invalid file type for video. Please upload a video with one of the following file types: mp4, mov ',
            })
        }
        else {
            this.setState({
                uploadErrorMsg: 'Oops. There was an error while uploading. Retry and if the error persists refresh the page and try again.',
            })
        }
        throw new Error('Server error')
        }

}
